module.exports = __webpack_public_path__ + "media/images/pic/saska/polygon_news_bigger-882ea27613d1bc97e320c83443119139.svg";